// Vue
import { mixins } from "vue-class-component";
import { Component, Prop, Inject, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Mixins
import { FormInput } from "@mgs/ci2019-common/src/mixins/form_input/FormInput";

@Component({
  name: "Checkbox",
  mixins: [template],
})
export default class UnimogCheckbox extends mixins(FormInput) {
  @Prop({ default: false })
  public value!: boolean;

  @Prop([String, Number])
  public trueValue!: any;

  @Inject({ from: "checkboxGroupTheme", default: null })
  public parentTheme!: string;

  @Inject({ from: "checkboxGroupDisabled", default: false })
  public parentDisabled!: boolean;

  @Prop()
  public label?: string;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: () => [] })
  public displayErrors!: string[];

  @Prop({ default: true })
  public showErrors!: boolean;

  @Prop()
  public id!: string;

  @Prop()
  public name!: string;

  @Prop()
  public tabindex!: string;

  @Prop()
  public img?: string;

  @Prop({ default: false })
  public isHighlight!: boolean;

  private isChecked: boolean = false;

  public get themeMap() {
    return 1;
  }

  public get filteredErrors() {
    return this.displayErrors.filter(
      (error) => error != "" && error != undefined && error != null
    );
  }

  public get errorClass() {
    return this.$slots["validation"] || this.filteredErrors.length > 0
      ? `${this.$appPrefix}-checkbox--error wb-e-check-${this.themeMap}--has-error`
      : "";
  }

  public get disabledClass() {
    return this.disabled || this.parentDisabled
      ? `${this.$appPrefix}-checkbox--disabled wb-e-check-${this.themeMap}--disabled`
      : "";
  }

  public get iconCheckboxClass() {
    return this.$slots["checked"] || this.$slots["unchecked"]
      ? `${this.$appPrefix}-checkbox--icon-checkbox`
      : "";
  }

  public get activeClass() {
    return this.isChecked ? `${this.$appPrefix}-unimog-checkbox--active` : "";
  }

  public get highlightClass() {
    return this.isHighlight
      ? `${this.$appPrefix}-unimog-checkbox--highlight`
      : "";
  }

  @Watch("value")
  private onValueChange() {
    this.isChecked = this.value;
  }

  public created() {
    this.$on("change", this.handleCheckboxGroupValueChange);
    this.$on("selectAll", this.handleSelectAll);
    this.isChecked = this.value;
  }

  public destroyed() {
    this.$off("change", this.handleCheckboxGroupValueChange);
    this.$off("selectAll", this.handleSelectAll);
  }

  private handleCheckboxGroupValueChange(value: any[]) {
    let values = value || [];

    let isChecked = values.includes(this.trueValue);
    if (this.isChecked != isChecked) {
      this.isChecked = isChecked;
      this.$emit("input", isChecked);
    }
  }

  public handleSelectAll(value) {
    this.isChecked = value;
    this.$emit("input", value);
    this.dispatch("CheckboxGroup", "change", [value, this.trueValue]);
  }

  public toggleChecked(e) {
    this.isChecked = !this.isChecked;
    this.$emit("input", this.isChecked);
    this.dispatch("CheckboxGroup", "change", [this.isChecked, this.trueValue]);
  }
}
